<template>
  <div class="bordered">

    <div class="container-fill" @click="toggle">
      <div>{{ account.name }}</div>
      <div class="disabled" v-show="account.expired">Expired</div>
      <div class="details-header" v-if="account.settings">
        Notifications: <span :class="{ enabled: account.settings.notifications, disabled: !account.settings.notifications }">{{ account.settings.notifications ? 'Enabled' : 'Disabled'}}</span>
      </div>
      <!--
      <div>
        (alerts: {{ account.total_alerts }}, keywords: {{ account.total_keywords }})
      </div>
      -->
    </div>

    <div class="details" v-show="isActive">

      <div id="accountButtons">
        <font-awesome-icon icon="trash" @click="deleteAccount()" title="Delete account"/>
      </div>

      <!-- Details -->
      <AccountDetails :account="account"/>

      <!-- Subscriptions -->
      <br/>
      <b>Subscriptions:</b>
      <AccountSubscriptions :account="account"/>

    </div>

    <pre class="debug" v-show="debugMode">{{ account }}</pre>
  
  </div>
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#accountButtons {
  display: inline-block;
  float: right;
}
.default {
  font-size: small;
}
.container {
  display: flex;
}
.container-fill {
  display: flex;
  justify-content: space-between;
}
.details {
  margin-top: 5px;
  border-top: 1px solid #cccccc;
  padding-top: 5px;
}
.details-header {
  font-size: small;
}
.details-header > h2,h3,h4 {
  font-size: initial;
  margin: 0px;
}
.enabled {
  color: green;
}
.disabled {
  color: red;
}
</style>

<script>
import { mapState } from 'vuex'
import AccountDetails from '@/components/AccountDetails.vue'
import AccountSubscriptions from '@/components/AccountSubscriptions.vue'

export default {
  name: 'account',
  components: {
    AccountDetails,
    AccountSubscriptions
  },
  props: {
    account: {
      type: Object,
      required: true
    }
  },
  computed: mapState([
    'debugMode'
  ]),
  data () {
    return {
      isActive: false,
    }
  },
  methods: {
    toggle: function (event) {
      if (event.target.tagName != 'DIV' && event.target.tagName != 'SPAN') return
      this.isActive = !this.isActive
    },
    deleteAccount () {
      if (!confirm('Are you sure? This will delete the account permanently!')) return
      this.$store.dispatch('deleteAccount', this.account)
    }
  }
}
</script>
